
import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import OrderListCommon from "@/components/order/order/OrderListCommon.vue";
import LockerNav from "@/components/locker/widget/LockerNav.vue";

@Component({
  components: {
    OrderListCommon,
    LockerNav,
  }
})
export default class LockersOrders extends Vue {
  @Prop({ default: 0 })
  private lockerId!: number
}
